import React from 'react'
import { useNavigate } from "react-router-dom"
import { isAuthenticated } from '../utils/auth'

const LandingPage = () => {
  const navigate = useNavigate();
  const loggedIn = isAuthenticated();

  return (
    <div className='landing-page'>
      <h1 className='landing-title'>Valhalla</h1>
      <p className='landing-subtitle'>Health Management</p>
      {/* <h2 className='landing-login-text'>Please Sign In</h2> */}
      {!loggedIn && (
        <button className='btn landing-login-btn' onClick={() => navigate('/login')}>Sign In</button>
      )}
      {/* <p>{process.env.REACT_APP_API_URL_BASE}</p> */}
    </div>
  )
}

export default LandingPage
